module.exports = __webpack_public_path__ + "assets/img/yb-1.85b8f997.jpg";